import { MapPin, ArrowRight } from "lucide-react";
import Money from "@/components/Money";

export default function CarDestinationsBlock({ car }) {
  return (
    <div className="py-8 border-b border-border">
      <h3 className="font-display text-xl font-medium mb-1">Pickup & drop-off</h3>
      <p className="text-sm text-neutral-500 mb-5">This vendor offers multiple destinations. Choose any combination at checkout.</p>
      {car.one_way_fee > 0 && (
        <div className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1 rounded-full bg-amber-50 text-amber-800 border border-amber-100 mb-4" data-testid="one-way-fee-banner">
          One-way fee: <Money amount={car.one_way_fee} className="font-semibold" /> when drop-off ≠ pickup
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="car-destinations">
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-3">Pickup options</div>
          <ul className="space-y-2">
            {(car.pickup_locations || []).map((loc) => (
              <li key={loc} className="flex items-center gap-2 text-sm">
                <MapPin className="h-3.5 w-3.5 text-blue-600" /> {loc}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-3">Drop-off options</div>
          <ul className="space-y-2">
            {(car.dropoff_locations || []).map((loc) => (
              <li key={loc} className="flex items-center gap-2 text-sm">
                <ArrowRight className="h-3.5 w-3.5 text-blue-600" /> {loc}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
